var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "td",
    { staticClass: "border-none align-top" },
    [_c("badge", { attrs: { text: _vm.badge, color: _vm.color } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }